import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import  StudentLeaderboard from "../../models/studentleaderboard.modal"
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, Table, UncontrolledTooltip } from 'reactstrap'
import StudentList from "../../models/studentlist.modal";
import { helper } from "lib/helper";

const Studentleaderboard = () => {
    const[modal,setModal] = useState();
    const[data, setData]= useState();
    const[studentlist, SetStudentlist]=useState();
    console.log("student list", studentlist)
    const toggleModal=()=>{
        setModal(!modal);
    }
    const Addleader =(event)=>{
      event.preventDefault();
      const form = new FormData(event.target);
      
      // Get student names for the selected IDs
      const getStudentName = (id) => {
        const student = studentlist?.data?.find(s => s.id === id);
        return student ? { id: id, name: student.name } : { id: id, name: "Unknown" };
      };
      
      // Simulate adding new leaderboard entry
      const newLeaderboard = {
        id: (data?.data?.length + 1).toString(),
        month_name: form.get("month_name"),
        rank1: getStudentName(form.get("rank_1")),
        rank2: getStudentName(form.get("rank_2")),
        rank3: getStudentName(form.get("rank_3"))
      };
      
      setTimeout(() => {
        setData(prevData => ({
          ...prevData,
          data: [...(prevData?.data || []), newLeaderboard]
        }));
        toggleModal();
        helper.sweetalert.toast("Student leaderboard added successfully", "success");
      }, 500);
    }
    const Studentleaderlist =()=>{
      // Dummy data for student leaderboard
      const dummyLeaderboardData = {
        data: [
          {
            id: "1",
            month_name: "January 2024",
            rank1: {
              id: "1",
              name: "Arjun Sharma"
            },
            rank2: {
              id: "2",
              name: "Priya Gupta"
            },
            rank3: {
              id: "3",
              name: "Rahul Verma"
            }
          },
          {
            id: "2",
            month_name: "December 2023",
            rank1: {
              id: "4",
              name: "Sneha Patel"
            },
            rank2: {
              id: "5",
              name: "Vikash Kumar"
            },
            rank3: {
              id: "6",
              name: "Anita Singh"
            }
          },
          {
            id: "3",
            month_name: "November 2023",
            rank1: {
              id: "7",
              name: "Rohit Joshi"
            },
            rank2: {
              id: "8",
              name: "Kavya Reddy"
            },
            rank3: {
              id: "9",
              name: "Amit Agarwal"
            }
          },
          {
            id: "4",
            month_name: "October 2023",
            rank1: {
              id: "10",
              name: "Meera Nair"
            },
            rank2: {
              id: "11",
              name: "Karan Malhotra"
            },
            rank3: {
              id: "12",
              name: "Divya Chopra"
            }
          }
        ]
      };
      
      setTimeout(() => {
        setData(dummyLeaderboardData);
      }, 1000);
    }
    const Studentlist = () =>{
      // Dummy data for student list
      const dummyStudentListData = {
        data: [
          { id: "1", name: "Arjun Sharma" },
          { id: "2", name: "Priya Gupta" },
          { id: "3", name: "Rahul Verma" },
          { id: "4", name: "Sneha Patel" },
          { id: "5", name: "Vikash Kumar" },
          { id: "6", name: "Anita Singh" },
          { id: "7", name: "Rohit Joshi" },
          { id: "8", name: "Kavya Reddy" },
          { id: "9", name: "Amit Agarwal" },
          { id: "10", name: "Meera Nair" },
          { id: "11", name: "Karan Malhotra" },
          { id: "12", name: "Divya Chopra" },
          { id: "13", name: "Sanjay Yadav" },
          { id: "14", name: "Pooja Sharma" },
          { id: "15", name: "Ravi Tiwari" },
          { id: "16", name: "Neha Bansal" },
          { id: "17", name: "Deepak Sinha" },
          { id: "18", name: "Ritika Jain" },
          { id: "19", name: "Manish Gupta" },
          { id: "20", name: "Swati Mishra" }
        ]
      };
      
      setTimeout(() => {
        SetStudentlist(dummyStudentListData);
      }, 500);
    }
    console.log("leader",data)
    useEffect(()=>{Studentleaderlist();
        Studentlist();
    },[])
  return (
    <Container className="px-4 py-7">
      <Card className="shadow">
     
      
          
            <CardHeader className="border-0 d-flex justify-content-between ">
              <h3 className="mb-0">Student Leader Board</h3>

              <div className="d-flex flex-row">
                <Button
                  size="sm"
                 onClick={toggleModal}
                  style={{ backgroundColor: "#080278", color: "white" }}
                  
                >
                  +Add
                </Button>
              </div>
            </CardHeader>
         
        
 <CardBody>
 <Table className="align-items-center table-flush" responsive>
    <thead className="thead-light">
    <tr>
              <th>S.NO</th>
              
              
              <th>Leader 1</th>
              <th>Leader 2</th>
             
              <th>Leader 3</th>
              <th>
               Month
              </th>
              </tr>
            </thead>
            <tbody>
    {data?.data?.map((item, index)=>{
      console.log("star",item)
        return(
            <tr>
            <td>{index + 1}</td>
           
            
            <td>{item?.rank1?.name}</td>
            <td>{item?.rank2?.name}</td>
            
            <td>
            
            {item?.rank3?.name}
          
            </td>
            <td>
             {item?.month_name}
            </td>
          </tr>
         
        )
    })}
         </tbody>  
           </Table>
           
    
      {/*add  module */}
      <Modal isOpen={modal} toggle={toggleModal} size="md">
        <ModalHeader toggle={toggleModal}>
          <h4> Add Student Leader Board </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={Addleader}>
          <Row>
          <Col md={12}>
              <FormGroup>
                <Label> Month</Label>
                <Input name="month_name" type="text"  style={{border: "1px solid #cad1d7",borderRadius: "0.375rem", padding:"4px"}} />
              </FormGroup>
            </Col>
          </Row>
         
        
          <Row>
          <Col md={12}>
              <FormGroup>
                <Label>
                    Leader 1
                </Label>
                <Input name="rank_1" type="select" placeholder="Enter Vedio Type" >
                <option value="">Select</option>
                {studentlist?.data?.map((item, index)=>{
                 
                  return(
                  <option index={index} value={item?.id}>{item?.name}</option>
                  )
                })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
         
            <Col md={12}>
              <FormGroup>
                <Label > Leader 2
                </Label>
                <Input name="rank_2" type="select" placeholder="Enter Vedio Type" >
                <option value="">Select</option>
                <option value="parent">Tutor</option>{studentlist?.data?.map((item, index)=>{
            
                  return(
                  <option index={index} value={item?.id}>{item?.name}</option>
                  )
                })}
                </Input>
              </FormGroup>
            </Col><Col md={12}>
              <FormGroup>
                <Label >Leader 3
                </Label>
                <Input name="rank_3" type="select" placeholder="Enter Vedio Type" >
                <option value="">Select</option>
                <option value="parent">Tutor</option>{studentlist?.data?.map((item, index)=>{
                 
                  return(
                  <option index={index} value={item?.id}>{item?.name}</option>
                  )
                })} </Input>
              </FormGroup>
            </Col>
          </Row>
          
          
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
            {/* 
                    {addsLoadig ? (
                      <Loader color={"blue"} />
                    ) : ( */}
            <Button
              color="primary"
              type="submit"
              style={{
                float: "right",
                marginLeft: "5%",
                backgroundColor: "#080278",
                color: "white",
              }}
              
            >
              Save
            </Button>
          </div>
          </Form>
        </ModalBody>
      </Modal>
      {/*end*/}
      </CardBody>
      </Card>
    </Container>
  )
}

export default Studentleaderboard
